'use strict';
import "core-js/stable";
import "regenerator-runtime/runtime";

import {Env} from './components/config/env';
import Settings from './components/config/settings';
import {Snippet} from './components/config/snippet';
import {Customization} from './components/config/customization';
import AppConfig from './components/config/config';

import AppLibrary from './components/app-library';
import {Loader} from './components/loader';
import Application from './components/application';

import * as ThirdPartyApps from './third-party-apps';


let env = new Env();
const APP_NAME = env.appName;

let settings = new Settings(APP_NAME);           // JS from CDN
let snippet = new Snippet(APP_NAME);             // Snippet from the theme
let customization = new Customization(APP_NAME); // Customization from the theme
let config = new AppConfig(env, settings, snippet, customization);
let library = new AppLibrary(APP_NAME, snippet, customization);

let theGreatLoader = new Loader(library, APP_NAME);

theGreatLoader.requireJQuery('1.7', '1.9.1');

theGreatLoader.enableSelectorPicker(
  page => {
    if (page === 'cart') {
      let _GET = library.requestGetVars();
      if (Spurit.globalSnippet.cart.items.length !== 1 && typeof (_GET.vid) !== 'undefined') {
        // Add exactly 1 line-item to the cart
        library.ajax('POST', '/cart/clear.js', null, () => {
          library.ajax('POST', '/cart/add.js', 'quantity=1&id=' + _GET.vid, () => {
            document.location.reload();
          });
        });
        return false;
      }
    }
    return page === 'collections' || page === 'products' || page === 'index' || page === 'cart';
  }
);

theGreatLoader.addResources(env.cdnStorePath + snippet.shopHash + '.js?' + snippet.cacheTimestamp);
theGreatLoader.addResources(env.cdnStorePath + snippet.shopHash + '.css?' + snippet.cacheTimestamp);
theGreatLoader.addResources(env.cdnCommonPath + 'common.css');
theGreatLoader.addResources(env.cdnJsLibPath + 'spurit.global-2.x.min.js');
//theGreatLoader.addResources('https://js-plugins.spurit.loc/js-global/build/spurit.global.min.js');

theGreatLoader.run(($, currentPage) => {
  // Run App
  config.init();
  theGreatLoader.enableStylePicker(config);
  Spurit.global.onReady(
    ['atc', 'selectors', 'cart', 'checkout', 'prices'],
    () => {
      (new ThirdPartyApps.BoostCommerceProductFilterAndSearch(APP_NAME, config)).fix();
      (new Application(config, library, currentPage)).run();
    },
    {
      checkout: {
        hash: config.snippet().shopHash,
        app_id: env.appId,
        app_name: APP_NAME
      }
    }
  );
});